module.exports = __webpack_public_path__ + "static/media/inp-success.54a1c6a2.svg";